<modal>
  <span header class="uppercase">{{customer}} {{'trả hàng' | lang}}  <span *ngIf="SKU">{{'mã' | lang}} {{SKU}}</span> <span *ngIf="color"> {{'màu' | lang}} {{color}}</span> ({{range.name}})</span>

  <text-filter [target]="details" class="std-margin-bottom" [placeholder]="'Tìm đơn'"></text-filter>

  <table responsive class="data">
    <tr>
      <th priority="7" class="text-right" style="width: 0">STT</th>
      <th priority="1"><sortable [target]="details" [extractor]="extractor('Tag')">{{'Đơn trả' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="details" [extractor]="extractor('LengthQuantity')">{{'Hàng mét' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('WeightQuantity')">{{'Hàng cân' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Khấu trừ' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th priority="6" class="text-right"><sortable [target]="details" [extractor]="extractor('BasePrice')">{{'Giá gốc' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('QuotePrice')">{{'Giá nhập' | lang}}</sortable></th>
      <th priority="2" class="text-right"><sortable [target]="details" [extractor]="extractor('Value')">{{'Thành tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of details.pageMatches; index as ix" class="text-top">
      <td><small>{{ix + 1 + details.pageIndex * details.pageSize}}</small></td>
      <td><invoice [tag]="i.Path[0]" [displays]="{stamp: true}" (unconfirmed)="unconfirmed($event)" [filters]="{ sku: SKU, color: color }"></invoice></td>
      <td>
        <div><span class="text-danger">{{i.Returns.LengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <small><b class="text-danger">{{i.Returns.LengthCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div><span class="text-danger">{{i.Returns.WeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
        <small><b class="text-danger">{{i.Returns.WeightCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div><span class="text-success">{{i.Returns.LengthQuantity - i.Returns.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-success">{{i.Returns.WeightQuantity - i.Returns.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        <div><span class="text-danger">{{i.Returns.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-danger">{{i.Returns.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        {{i.Returns.BaseWorth / (i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="i.Returns.LengthCount > 0 && i.Returns.WeightCount > 0 ? 0 : i.Returns.LengthCount > 0 ? 1 : 2"></cny-per-unit>
      </td>
      <td>
        {{i.Returns.QuoteValue / (i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity) | number : '1.0-0' : 'en-US'}}<vnd-per-unit [type]="i.Returns.LengthCount > 0 && i.Returns.WeightCount > 0 ? 0 : i.Returns.LengthCount > 0 ? 1 : 2"></vnd-per-unit>
        <div class="small">
          {{i.Returns.QuoteWorth / (i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="i.Returns.LengthCount > 0 && i.Returns.WeightCount > 0 ? 0 : i.Returns.LengthCount > 0 ? 1 : 2"></cny-per-unit>
        </div>
      </td>
      <td>
        <b class="text-danger">{{i.Returns.QuoteValue | number : '1.0-0' : 'en-US'}}</b><vnd></vnd>
        <div class="small">
          {{i.Returns.QuoteWorth | number : '1.1-1' : 'en-US'}}<cny></cny>
        </div>
      </td>
    </tr>

    <tr *ngIf="details.pages.length > 1">
      <td [colSpan]="9" style="display: table-cell !important" class="text-center"><pagination [target]="details"></pagination></td>
    </tr>

    <tr class="footer bold text-top" *ngIf="details.matches.length > 1">
      <td></td>
      <td>{{'TỔNG' | lang}} ({{details.matches.length}})</td>
      <td>
        <div>{{sum('LengthQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <small>{{sum('LengthCount') | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div>{{sum('WeightQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
        <small>{{sum('WeightCount') | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div>{{sum('ReducedLength') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div>{{sum('ReducedWeight') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        <div>{{sum('LengthQuoteQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div>{{sum('WeightQuoteQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        {{sum('Base') / (sum('LengthQuoteQuantity') + sum('WeightQuoteQuantity')) | number : '1.1-1' : 'en-US'}}
        <cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>
        {{sum('Value') / (sum('LengthQuoteQuantity') + sum('WeightQuoteQuantity')) | number : '1.0-0' : 'en-US'}}
        <vnd-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></vnd-per-unit>

        <div class="small">
          {{sum('Quote') / (sum('LengthQuoteQuantity') + sum('WeightQuoteQuantity')) | number : '1.1-1' : 'en-US'}}
          <cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit>
        </div>
      </td>
      <td>
        {{sum('Value') | number : '1.0-0' : 'en-US'}}<vnd></vnd>
        <div class="small">{{sum('Quote') | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
    </tr>
  </table>
</modal>
